// Lightweight UI-label translations (English / Spanish / French).
// Article content remains in its original language.
export const translations = {
  en: {
    nav: {
      myStory: 'My Story',
      subscribe: 'Subscribe',
      trending: 'Trending',
      bookmarks: 'Bookmarks',
      leaderboard: 'Leaderboard',
      admin: 'Admin',
      login: 'Login',
      logout: 'Logout',
    },
    home: {
      title: "Today's Wit",
      subtitle: 'Real news. Real laughs. Zero boring stuff. Get updated in 2 minutes.',
      noNews: 'No news available yet. Check back soon!',
    },
    recommended: {
      title: 'Recommended for You',
      subtitle: 'Picked from the categories you read and bookmark most.',
    },
    leaderboard: {
      title: 'Leaderboard',
      subtitle: 'The wittiest readers of Daily Wit. Earn points by reading, sharing and bookmarking.',
      rank: 'Rank',
      reader: 'Reader',
      points: 'Points',
      streak: 'Streak',
      badges: 'Badges',
      you: 'You',
      yourRank: 'Your rank',
      empty: 'No rankings yet — be the first to earn points!',
      loginPrompt: 'Log in to appear on the leaderboard and start earning points.',
    },
    badges: {
      title: 'Badges',
      locked: 'Locked',
      earned: 'Earned',
    },
    stats: {
      points: 'Points',
      streak: 'Day Streak',
      shares: 'Shares',
      reads: 'Reads',
      title: 'Your Stats',
      yourBadges: 'Your Badges',
      keepStreak: 'Keep your streak alive! Read news daily to earn more points and unlock badges.',
    },
    bookmarks: {
      title: 'Your Bookmarks',
      subtitle: 'All your saved wit in one place',
      empty: 'No bookmarks yet. Start saving your favorite news!',
    },
    trending: {
      title: 'Trending Now',
      subtitle: "The most viral news right now. What everyone's talking about!",
      empty: 'No trending news yet. Be the first to engage!',
    },
    auth: {
      welcomeBack: 'Welcome Back',
      joinUs: 'Join Us',
      loginSubtitle: 'Login to bookmark your favorite news',
      registerSubtitle: 'Create an account to get started',
      email: 'Email',
      password: 'Password',
      login: 'Login',
      signUp: 'Sign Up',
      forgot: 'Forgot password?',
      noAccount: "Don't have an account? Sign up",
      haveAccount: 'Already have an account? Login',
    },
  },
  es: {
    nav: {
      myStory: 'Mi Historia',
      subscribe: 'Suscribirse',
      trending: 'Tendencias',
      bookmarks: 'Guardados',
      leaderboard: 'Clasificación',
      admin: 'Admin',
      login: 'Entrar',
      logout: 'Salir',
    },
    home: {
      title: 'El Ingenio de Hoy',
      subtitle: 'Noticias reales. Risas reales. Nada aburrido. Actualízate en 2 minutos.',
      noNews: 'Aún no hay noticias. ¡Vuelve pronto!',
    },
    recommended: {
      title: 'Recomendado para Ti',
      subtitle: 'Elegido según las categorías que más lees y guardas.',
    },
    leaderboard: {
      title: 'Clasificación',
      subtitle: 'Los lectores más ingeniosos de Daily Wit. Gana puntos leyendo, compartiendo y guardando.',
      rank: 'Puesto',
      reader: 'Lector',
      points: 'Puntos',
      streak: 'Racha',
      badges: 'Insignias',
      you: 'Tú',
      yourRank: 'Tu puesto',
      empty: 'Aún no hay clasificación, ¡sé el primero en ganar puntos!',
      loginPrompt: 'Inicia sesión para aparecer en la clasificación y ganar puntos.',
    },
    badges: {
      title: 'Insignias',
      locked: 'Bloqueada',
      earned: 'Obtenida',
    },
    stats: {
      points: 'Puntos',
      streak: 'Días Seguidos',
      shares: 'Compartidos',
      reads: 'Lecturas',
      title: 'Tus Estadísticas',
      yourBadges: 'Tus Insignias',
      keepStreak: '¡Mantén tu racha! Lee noticias a diario para ganar más puntos y desbloquear insignias.',
    },
    bookmarks: {
      title: 'Tus Guardados',
      subtitle: 'Todo tu ingenio guardado en un solo lugar',
      empty: 'Aún no tienes guardados. ¡Empieza a guardar tus noticias favoritas!',
    },
    trending: {
      title: 'Tendencias Ahora',
      subtitle: 'Las noticias más virales del momento. ¡De lo que todos hablan!',
      empty: 'Aún no hay tendencias. ¡Sé el primero en participar!',
    },
    auth: {
      welcomeBack: 'Bienvenido de Nuevo',
      joinUs: 'Únete',
      loginSubtitle: 'Inicia sesión para guardar tus noticias favoritas',
      registerSubtitle: 'Crea una cuenta para empezar',
      email: 'Correo',
      password: 'Contraseña',
      login: 'Entrar',
      signUp: 'Registrarse',
      forgot: '¿Olvidaste tu contraseña?',
      noAccount: '¿No tienes cuenta? Regístrate',
      haveAccount: '¿Ya tienes cuenta? Inicia sesión',
    },
  },
  fr: {
    nav: {
      myStory: 'Mon Histoire',
      subscribe: "S'abonner",
      trending: 'Tendances',
      bookmarks: 'Favoris',
      leaderboard: 'Classement',
      admin: 'Admin',
      login: 'Connexion',
      logout: 'Déconnexion',
    },
    home: {
      title: "L'Esprit du Jour",
      subtitle: 'De vraies infos. De vrais rires. Rien d’ennuyeux. À jour en 2 minutes.',
      noNews: 'Pas encore d’actualités. Revenez bientôt !',
    },
    recommended: {
      title: 'Recommandé pour Vous',
      subtitle: 'Choisi selon les catégories que vous lisez et enregistrez le plus.',
    },
    leaderboard: {
      title: 'Classement',
      subtitle: 'Les lecteurs les plus spirituels de Daily Wit. Gagnez des points en lisant, partageant et enregistrant.',
      rank: 'Rang',
      reader: 'Lecteur',
      points: 'Points',
      streak: 'Série',
      badges: 'Badges',
      you: 'Vous',
      yourRank: 'Votre rang',
      empty: 'Pas encore de classement — soyez le premier à gagner des points !',
      loginPrompt: 'Connectez-vous pour apparaître au classement et gagner des points.',
    },
    badges: {
      title: 'Badges',
      locked: 'Verrouillé',
      earned: 'Obtenu',
    },
    stats: {
      points: 'Points',
      streak: 'Jours de Suite',
      shares: 'Partages',
      reads: 'Lectures',
      title: 'Vos Statistiques',
      yourBadges: 'Vos Badges',
      keepStreak: 'Gardez votre série ! Lisez chaque jour pour gagner des points et débloquer des badges.',
    },
    bookmarks: {
      title: 'Vos Favoris',
      subtitle: 'Tout votre esprit enregistré au même endroit',
      empty: 'Aucun favori pour l’instant. Commencez à enregistrer vos actus préférées !',
    },
    trending: {
      title: 'Tendances du Moment',
      subtitle: 'Les actus les plus virales en ce moment. Ce dont tout le monde parle !',
      empty: 'Pas encore de tendances. Soyez le premier à participer !',
    },
    auth: {
      welcomeBack: 'Bon Retour',
      joinUs: 'Rejoignez-nous',
      loginSubtitle: 'Connectez-vous pour enregistrer vos actus préférées',
      registerSubtitle: 'Créez un compte pour commencer',
      email: 'E-mail',
      password: 'Mot de passe',
      login: 'Connexion',
      signUp: "S'inscrire",
      forgot: 'Mot de passe oublié ?',
      noAccount: 'Pas de compte ? Inscrivez-vous',
      haveAccount: 'Vous avez déjà un compte ? Connexion',
    },
  },
};
